var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgCompany(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.333 1.667a2 2 0 0 1 2 2V7.5h3a2 2 0 0 1 2 2v6.833a2 2 0 0 1-2 2h-3.5c-.265 0-.519-.051-.75-.145-.231.094-.484.145-.75.145H3.667a2 2 0 0 1-2-2V3.667a2 2 0 0 1 2-2h7.666zM5.667 12.5h-.5a1 1 0 0 0-.994.883l-.006.117v.5a1 1 0 0 0 .883.993l.117.007h.5a1 1 0 0 0 .993-.883L6.667 14v-.5a1 1 0 0 0-1-1zm4.166 0h-.5a1 1 0 0 0-.993.883l-.007.117v.5a1 1 0 0 0 .884.993l.116.007h.5a1 1 0 0 0 .994-.883l.006-.117v-.5a1 1 0 0 0-1-1zM5.667 8.333h-.5a1 1 0 0 0-.994.884l-.006.116v.5a1 1 0 0 0 .883.994l.117.006h.5a1 1 0 0 0 .993-.883l.007-.117v-.5a1 1 0 0 0-1-1zm4.166 0h-.5a1 1 0 0 0-.993.884l-.007.116v.5a1 1 0 0 0 .884.994l.116.006h.5a1 1 0 0 0 .994-.883l.006-.117v-.5a1 1 0 0 0-1-1zM5.667 4.167h-.5a1 1 0 0 0-.994.883l-.006.117v.5a1 1 0 0 0 .883.993l.117.007h.5a1 1 0 0 0 .993-.884l.007-.116v-.5a1 1 0 0 0-1-1zm4.166 0h-.5a1 1 0 0 0-.993.883l-.007.117v.5a1 1 0 0 0 .884.993l.116.007h.5a1 1 0 0 0 .994-.884l.006-.116v-.5a1 1 0 0 0-1-1z",
    fill: "currentColor",
    fillRule: "evenodd"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCompany);
export default __webpack_public_path__ + "static/media/company.22ea848c.svg";
export { ForwardRef as ReactComponent };